import { Link } from 'react-router-dom';

const SkipLinks = () => {
  return (
    <div className="sr-only focus-within:not-sr-only">
      <Link
        to="#main-content"
        className="fixed top-0 left-0 z-[9999] bg-primary text-primary-foreground px-4 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        Skip to main content
      </Link>
    </div>
  );
};

export default SkipLinks;
